import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify"; // if you're using toast notifications
import axios from "axios";
import { EmailLogsList } from "../../redux/actions/userAction/userAction";
import LoaderButton from "../Common/LoaderButton";
import { handleApiError } from "../../helpers/errorResponseHelper";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const ActivityDropDown = (props) => {
  const { action } = props;
  const dispatch = useDispatch();
  const employeeData = useSelector((state) => state.user);
  const accessToken = localStorage.getItem("accessToken");
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [searchData, setSearchData] = useState({
    searchKey: "",
    page: 1,
    limit: 10,
    order: -1,
    filterData: {},
  });

  const handleResend = async (action) => {
    setIsLoading(true);

    try {
      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/emailLog/resend/${action._id}`;
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };

      const payload = {
        emailTo: action.emailTo,
        body: action.body,
      };

      const response = await axios.post(webApiUrl, payload, headerObject);

      if (response.data.success) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        const payload = {
          page: searchData.page,
          order: searchData.order,
          limit: searchData.limit,
          toDate: searchData.filterData?.toDate,
          fromDate: searchData.filterData?.fromDate,
          organizationId: employeeData?.userData?.organizationId,
        };
        dispatch(EmailLogsList(payload, accessToken));
      } else {
        toast.error(response.data.message || "Resend failed.", {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Resend error:", error);
      // @ts-ignore
      if (handleApiError(error)) return;
    } finally {
      setIsLoading(false);
      setShowConfirm(false);
    }
  };

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#000"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16"
          >
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
          </svg>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => setShowConfirm(true)}
            style={{ cursor: "pointer" }}
          >
            <svg
              height="511pt"
              viewBox="0 0 511 511.99871"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              className="deleteSvg me-2"
            >
              <path d="m400.105469 44.0625 26.03125-5.949219c8.304687-1.894531 13.496093-10.164062 11.597656-18.46875-1.894531-8.300781-10.164063-13.5-18.464844-11.597656l-62.859375 14.359375c-8.300781 1.898438-13.496094 10.167969-11.597656 18.46875l14.359375 62.859375c1.632813 7.148437 7.988281 11.988281 15.019531 11.988281 1.136719 0 2.292969-.125 3.449219-.390625 8.300781-1.894531 13.496094-10.164062 11.597656-18.46875l-6.191406-27.105469c68.722656 46.664063 106.5 127.53125 97.171875 211.183594-6.660156 59.765625-36.195312 113.355469-83.167969 150.902344-40.296875 32.214844-89.285156 49.3125-140.132812 49.308594-8.417969 0-16.890625-.46875-25.378907-1.414063-8.472656-.945312-16.089843 5.15625-17.035156 13.617188-.945312 8.464843 5.152344 16.089843 13.617188 17.035156 9.65625 1.078125 19.28125 1.609375 28.855468 1.609375 57.8125-.003906 113.515626-19.441406 159.332032-56.066406 53.402344-42.691406 86.988281-103.625 94.5625-171.574219 10.617187-95.226563-32.449219-187.277344-110.765625-240.296875zm0 0" />
              <path d="m151.140625 405.21875c-1.894531-8.300781-10.164063-13.496094-18.46875-11.597656-8.300781 1.898437-13.492187 10.164062-11.597656 18.46875l6.523437 28.558594c-67.253906-46.894532-104.074218-126.882813-94.851562-209.589844 6.660156-59.765625 36.195312-113.355469 83.167968-150.902344 46.96875-37.546875 105.75-54.550781 165.511719-47.894531 8.46875.957031 16.089844-5.152344 17.035157-13.617188.941406-8.464843-5.152344-16.089843-13.617188-17.035156-67.953125-7.578125-134.785156 11.761719-188.191406 54.457031-53.402344 42.691406-86.984375 103.625-94.558594 171.574219-10.4375 93.601563 30.996094 184.136719 106.792969 237.554687l-24.710938 5.644532c-8.300781 1.894531-13.496093 10.164062-11.597656 18.46875 1.632813 7.144531 7.984375 11.988281 15.019531 11.988281 1.136719 0 2.292969-.125 3.449219-.390625l62.855469-14.359375c8.304687-1.898437 13.496094-10.167969 11.597656-18.46875zm0 0" />
              <path d="m391.09375 151.652344h-267.382812c-8.515626 0-15.417969 6.902344-15.417969 15.421875v177.878906c0 8.515625 6.902343 15.421875 15.417969 15.421875h267.382812c8.515625 0 15.421875-6.90625 15.421875-15.421875v-177.878906c0-8.519531-6.902344-15.421875-15.421875-15.421875zm-39.847656 30.839844-93.84375 85.421874-93.839844-85.421874zm-212.113282 147.039062v-127.570312l107.890626 98.207031c2.941406 2.675781 6.660156 4.015625 10.378906 4.015625s7.4375-1.339844 10.378906-4.015625l107.890625-98.207031v127.570312zm0 0" />
            </svg>
            Resend
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Resend</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          Are you sure you want to resend the Email logs to{" "}
          <strong>{action.emailTo}</strong> ?
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowConfirm(false)} className="add-minutes Mom-btn btn">
            <p className="mb-0">Cancel</p>
          </Button>

          {!isLoading ? (
            <button
              onClick={() => handleResend(props.action)}
              disabled={isLoading}
              className="create-meeting-button Mom-btn btn"
            >
              <p className="mb-0">Yes, Resend</p>
            </button>
          ) : (
            <SmallLoaderButton />
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ActivityDropDown;
